import React, { useState } from "react";
import "./RewardsPage.css";
import { useLanguage } from "../contexts/LanguageContext";
import { useFirebase } from "../contexts/FirebaseContext";
import benchyImage from "../assets/reward-benchy.png";
import turtleImage from "../assets/reward-turtle.png";
import ninjaStarImage from "../assets/reward-ninja-star.png";
import ticTacLauncherImage from "../assets/reward-tic-tac-launcher.jpg";
import ticTacLauncherAdvancedImage from "../assets/reward-tic-tac-launcher-advanced.png";
import ticTacBulletImage from "../assets/reward-tic-tac-bullet.png";
import ticTacBoxAdapterImage from "../assets/reward-tic-tac-box-adapter.png";
import gyroSpinnerImage from "../assets/reward-gyro-spinner.jpg";
import gravitraxRailsImage from "../assets/reward-gravitrax-rails.png";
import flyingBladeImage from "../assets/reward-flying-blade.png";
import flyingBladePropellerImage from "../assets/reward-flying-blade-propeller.png";
import { FILAMENT_COLORS } from "../constants/filamentColors";
import {
  buildShippingAddressOptions,
  formatShippingAddressLabel,
  rememberShippingAddress,
} from "../constants/shippingAddresses";

const BenchyIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={benchyImage}
    alt=""
  />
);

const TurtleIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={turtleImage}
    alt=""
  />
);

const NinjaStarIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={ninjaStarImage}
    alt=""
  />
);

const TicTacLauncherIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={ticTacLauncherImage}
    alt=""
  />
);

const TicTacLauncherAdvancedIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={ticTacLauncherAdvancedImage}
    alt=""
  />
);

const TicTacBulletIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={ticTacBulletImage}
    alt=""
  />
);

const TicTacBoxAdapterIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={ticTacBoxAdapterImage}
    alt=""
  />
);

const GyroSpinnerIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={gyroSpinnerImage}
    alt=""
  />
);

const GravitraxRailsIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={gravitraxRailsImage}
    alt=""
  />
);

const FlyingBladeIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={flyingBladeImage}
    alt=""
  />
);

const FlyingBladePropellerIllustration = () => (
  <img
    className="sw-reward-art sw-reward-art--photo"
    src={flyingBladePropellerImage}
    alt=""
  />
);

const REWARDS = [
  {
    id: "benchy",
    nameKey: "rewardBenchy",
    descKey: "rewardBenchyDesc",
    status: "featured",
    statusKey: "rewardStatusFirst",
    cost: 200,
    Illustration: BenchyIllustration,
  },
  {
    id: "turtle",
    nameKey: "rewardTurtle",
    descKey: "rewardTurtleDesc",
    status: "locked",
    statusKey: "rewardStatusLocked",
    cost: 400,
    Illustration: TurtleIllustration,
  },
  {
    id: "ninja-star",
    nameKey: "rewardNinjaStar",
    descKey: "rewardNinjaStarDesc",
    status: "locked",
    statusKey: "rewardStatusLocked",
    cost: 200,
    Illustration: NinjaStarIllustration,
  },
  {
    id: "tic-tac-launcher",
    nameKey: "rewardTicTacLauncher",
    descKey: "rewardTicTacLauncherDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 500,
    Illustration: TicTacLauncherIllustration,
  },
  {
    id: "tic-tac-launcher-advanced",
    nameKey: "rewardTicTacLauncherAdvanced",
    descKey: "rewardTicTacLauncherAdvancedDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 700,
    Illustration: TicTacLauncherAdvancedIllustration,
  },
  {
    id: "tic-tac-bullet",
    nameKey: "rewardTicTacBullet",
    descKey: "rewardTicTacBulletDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 200,
    Illustration: TicTacBulletIllustration,
  },
  {
    id: "tic-tac-box-adapter",
    nameKey: "rewardTicTacBoxAdapter",
    descKey: "rewardTicTacBoxAdapterDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 150,
    Illustration: TicTacBoxAdapterIllustration,
  },
  {
    id: "gyro",
    nameKey: "rewardGyro",
    descKey: "rewardGyroDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 450,
    Illustration: GyroSpinnerIllustration,
  },
  {
    id: "gravitrax-rails",
    nameKey: "rewardGravitraxRails",
    descKey: "rewardGravitraxRailsDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 350,
    Illustration: GravitraxRailsIllustration,
  },
  {
    id: "flying-blade",
    nameKey: "rewardFlyingBlade",
    descKey: "rewardFlyingBladeDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 750,
    Illustration: FlyingBladeIllustration,
  },
  {
    id: "flying-blade-propeller",
    nameKey: "rewardFlyingBladePropeller",
    descKey: "rewardFlyingBladePropellerDesc",
    status: "coming",
    statusKey: "rewardStatusComing",
    cost: 200,
    Illustration: FlyingBladePropellerIllustration,
  },
];

const RewardsPage = () => {
  const { t } = useLanguage();
  const { displayName, points, submitRewardClaim, getUserRewardClaims } =
    useFirebase();
  const [claimingReward, setClaimingReward] = useState(null);
  const [shippingName, setShippingName] = useState("");
  const [address, setAddress] = useState("");
  const [addressShortcut, setAddressShortcut] = useState("");
  const [addressOptions, setAddressOptions] = useState([]);
  const [pastAddresses, setPastAddresses] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [addressSavedMessage, setAddressSavedMessage] = useState("");
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [newAddressDraft, setNewAddressDraft] = useState("");
  const [addAddressError, setAddAddressError] = useState("");

  const refreshAddressOptions = (extraAddresses = pastAddresses) => {
    setAddressOptions(buildShippingAddressOptions(extraAddresses));
  };

  const openClaimModal = async (reward) => {
    if (points < (reward.cost || 0)) {
      setError("");
      return;
    }

    setClaimingReward(reward);
    setShippingName(displayName || "");
    setAddress("");
    setAddressShortcut("");
    setSelectedColor("");
    setError("");
    setSuccessMessage("");
    setAddressSavedMessage("");
    setShowAddAddressModal(false);
    setNewAddressDraft("");
    setAddAddressError("");

    try {
      const claims = await getUserRewardClaims();
      const fromClaims = claims
        .filter((claim) => claim.address)
        .map((claim, index) => ({
          id: `past-${claim.id || index}`,
          label: formatShippingAddressLabel(claim.address),
          address: claim.address,
        }));
      setPastAddresses(fromClaims);
      setAddressOptions(buildShippingAddressOptions(fromClaims));
    } catch (err) {
      console.error("Error loading address shortcuts:", err);
      setPastAddresses([]);
      setAddressOptions(buildShippingAddressOptions());
    }
  };

  const closeClaimModal = () => {
    if (isSubmitting) return;
    setClaimingReward(null);
    setError("");
    setSuccessMessage("");
    setAddressSavedMessage("");
    setShowAddAddressModal(false);
    setNewAddressDraft("");
    setAddAddressError("");
  };

  const handleAddressShortcutChange = (event) => {
    const nextId = event.target.value;
    setAddressShortcut(nextId);
    setError("");
    setAddressSavedMessage("");

    if (!nextId) {
      setAddress("");
      return;
    }

    const selected = addressOptions.find((option) => option.id === nextId);
    if (selected) {
      setAddress(selected.address);
    }
  };

  const applySavedAddress = (trimmedAddress) => {
    rememberShippingAddress(trimmedAddress);
    refreshAddressOptions();

    const options = buildShippingAddressOptions(pastAddresses);
    const saved = options.find((option) => option.address === trimmedAddress);
    if (saved) {
      setAddressShortcut(saved.id);
    } else {
      setAddressShortcut("");
    }
    setAddress(trimmedAddress);
    setAddressSavedMessage(t("rewardClaimAddressSaved"));
    setError("");
  };

  const handleSaveAddress = () => {
    const trimmedAddress = address.trim();
    if (!trimmedAddress) {
      setError(t("rewardClaimAddressRequired"));
      return;
    }
    applySavedAddress(trimmedAddress);
  };

  const openAddAddressModal = () => {
    setNewAddressDraft("");
    setAddAddressError("");
    setShowAddAddressModal(true);
  };

  const closeAddAddressModal = () => {
    setShowAddAddressModal(false);
    setNewAddressDraft("");
    setAddAddressError("");
  };

  const handleSaveNewAddressFromModal = (event) => {
    event.preventDefault();
    const trimmedAddress = newAddressDraft.trim();
    if (!trimmedAddress) {
      setAddAddressError(t("rewardClaimAddressRequired"));
      return;
    }
    applySavedAddress(trimmedAddress);
    closeAddAddressModal();
  };

  const handleClaimSubmit = async (e) => {
    e.preventDefault();
    if (!claimingReward) return;

    const trimmedName = shippingName.trim();
    const trimmedAddress = address.trim();

    if (!trimmedName) {
      setError(t("rewardClaimNameRequired"));
      return;
    }
    if (!trimmedAddress) {
      setError(t("rewardClaimAddressRequired"));
      return;
    }
    if (!selectedColor) {
      setError(t("rewardClaimColorRequired"));
      return;
    }

    const cost = Number(claimingReward.cost) || 0;
    if (points < cost) {
      setError(t("rewardClaimInsufficientStars"));
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      await submitRewardClaim({
        rewardId: claimingReward.id,
        rewardName: t(claimingReward.nameKey),
        color: selectedColor,
        shippingName: trimmedName,
        address: trimmedAddress,
        cost,
      });
      rememberShippingAddress(trimmedAddress);
      setSuccessMessage(t("rewardClaimSuccess"));
      setTimeout(() => {
        setClaimingReward(null);
        setSuccessMessage("");
        setIsSubmitting(false);
      }, 1400);
    } catch (err) {
      console.error("Error claiming reward:", err);
      setError(
        err?.code === "insufficient-stars"
          ? t("rewardClaimInsufficientStars")
          : t("rewardClaimError")
      );
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sw-rewards-page">
      <header className="sw-rewards-header">
        <div>
          <p className="sw-rewards-eyebrow">{t("rewardsEyebrow")}</p>
          <h1 className="sw-rewards-heading">{t("rewardsTitle")}</h1>
          <p className="sw-rewards-sub">{t("rewardsSubtitle")}</p>
        </div>
      </header>

      <div className="sw-rewards-gallery">
        {REWARDS.map((reward) => {
          const {
            id,
            nameKey,
            descKey,
            status,
            statusKey,
            cost,
            Illustration,
          } = reward;
          const hasEnoughStars = points >= cost;
          const canClaim = hasEnoughStars;
          const claimLabel = !hasEnoughStars
            ? t("rewardClaimNeedStars").replace("{cost}", String(cost))
            : t("claimReward");
          const claimTitle = !hasEnoughStars
            ? t("rewardClaimInsufficientStars")
            : undefined;

          return (
            <article
              key={id}
              className={`sw-reward-card ${
                status === "featured" ? "is-featured" : ""
              } ${status === "locked" ? "is-locked" : ""}`}
            >
              <div className="sw-reward-card-media">
                {status === "featured" && (
                  <span className={`sw-reward-badge sw-reward-badge--${status}`}>
                    {t(statusKey)}
                  </span>
                )}
                <Illustration />
              </div>
              <div className="sw-reward-card-body">
                <h2 className="sw-reward-name">{t(nameKey)}</h2>
                <p className="sw-reward-desc">{t(descKey)}</p>
                <div className="sw-reward-meta">
                  <span className="sw-reward-cost">
                    {cost} {t("stars")}
                  </span>
                  <span className="sw-reward-print-tag">{t("rewardPrintTag")}</span>
                </div>
                <button
                  type="button"
                  className={`sw-reward-claim-btn ${
                    canClaim ? "" : "is-disabled"
                  }`}
                  onClick={() => canClaim && openClaimModal(reward)}
                  disabled={!canClaim}
                  aria-disabled={!canClaim}
                  title={claimTitle}
                >
                  {claimLabel}
                </button>
              </div>
            </article>
          );
        })}
      </div>

      {claimingReward && (
        <div className="sw-claim-modal-overlay" onClick={closeClaimModal}>
          <div
            className="sw-claim-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="claim-modal-title"
          >
            <h3 id="claim-modal-title">
              {t("claimRewardTitle")} — {t(claimingReward.nameKey)}
            </h3>
            <p className="sw-claim-modal-sub">{t("claimRewardSubtitle")}</p>

            {successMessage ? (
              <p className="sw-claim-success">{successMessage}</p>
            ) : (
              <form onSubmit={handleClaimSubmit} className="sw-claim-form">
                <label className="sw-claim-label" htmlFor="claim-shipping-name">
                  {t("rewardClaimName")}
                </label>
                <input
                  id="claim-shipping-name"
                  type="text"
                  className="sw-claim-input"
                  value={shippingName}
                  onChange={(e) => {
                    setShippingName(e.target.value);
                    setError("");
                  }}
                  placeholder={t("rewardClaimNamePlaceholder")}
                  disabled={isSubmitting}
                  autoFocus
                />

                <label className="sw-claim-label" htmlFor="claim-address-shortcut">
                  {t("rewardClaimAddressShortcut")}
                </label>
                <select
                  id="claim-address-shortcut"
                  className="sw-claim-select"
                  value={addressShortcut}
                  onChange={handleAddressShortcutChange}
                  disabled={isSubmitting}
                >
                  <option value="">
                    {t("rewardClaimAddressShortcutPlaceholder")}
                  </option>
                  {addressOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </select>

                {address.trim() ? (
                  <>
                    <label className="sw-claim-label" htmlFor="claim-address">
                      {t("rewardClaimAddress")}
                    </label>
                    <textarea
                      id="claim-address"
                      className="sw-claim-textarea"
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        setAddressShortcut("");
                        setAddressSavedMessage("");
                        setError("");
                      }}
                      placeholder={t("rewardClaimAddressPlaceholder")}
                      rows={3}
                      disabled={isSubmitting}
                    />
                    <button
                      type="button"
                      className="sw-claim-save-address"
                      onClick={handleSaveAddress}
                      disabled={isSubmitting || !address.trim()}
                    >
                      {t("rewardClaimSaveAddress")}
                    </button>
                    {addressSavedMessage && (
                      <p className="sw-claim-address-saved">
                        {addressSavedMessage}
                      </p>
                    )}
                  </>
                ) : (
                  <p className="sw-claim-address-hint">
                    {t("rewardClaimAddressHint")}
                  </p>
                )}

                <fieldset className="sw-claim-colors">
                  <legend className="sw-claim-label">{t("rewardClaimColor")}</legend>
                  <div className="sw-claim-color-grid" role="radiogroup">
                    {FILAMENT_COLORS.map(({ id, hex, label, isLight, isRainbow }) => (
                      <button
                        key={id}
                        type="button"
                        role="radio"
                        aria-checked={selectedColor === id}
                        aria-label={label}
                        title={label}
                        className={`sw-claim-color-swatch ${
                          selectedColor === id ? "is-selected" : ""
                        } ${isLight ? "is-light" : ""} ${
                          isRainbow ? "is-rainbow" : ""
                        }`}
                        style={isRainbow ? undefined : { "--swatch-color": hex }}
                        onClick={() => {
                          setSelectedColor(id);
                          setError("");
                        }}
                        disabled={isSubmitting}
                      />
                    ))}
                  </div>
                </fieldset>

                <button
                  type="button"
                  className="sw-claim-add-address"
                  onClick={openAddAddressModal}
                  disabled={isSubmitting}
                >
                  {t("rewardClaimAddAnAddress")}
                </button>

                {error && <p className="sw-claim-error">{error}</p>}

                <div className="sw-claim-actions">
                  <button
                    type="button"
                    className="sw-claim-cancel"
                    onClick={closeClaimModal}
                    disabled={isSubmitting}
                  >
                    {t("cancel")}
                  </button>
                  <button
                    type="submit"
                    className="sw-claim-submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? t("saving") : t("rewardClaimSubmit")}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {showAddAddressModal && (
        <div
          className="sw-claim-modal-overlay sw-claim-modal-overlay--nested"
          onClick={closeAddAddressModal}
        >
          <div
            className="sw-claim-modal sw-claim-modal--nested"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="add-address-modal-title"
          >
            <h3 id="add-address-modal-title">{t("rewardClaimAddNewAddress")}</h3>
            <p className="sw-claim-modal-sub">{t("rewardClaimAddAddressSubtitle")}</p>
            <form
              className="sw-claim-form"
              onSubmit={handleSaveNewAddressFromModal}
            >
              <label className="sw-claim-label" htmlFor="claim-new-address">
                {t("rewardClaimAddress")}
              </label>
              <textarea
                id="claim-new-address"
                className="sw-claim-textarea"
                value={newAddressDraft}
                onChange={(e) => {
                  setNewAddressDraft(e.target.value);
                  setAddAddressError("");
                }}
                placeholder={t("rewardClaimAddressPlaceholder")}
                rows={4}
                autoFocus
              />
              {addAddressError && (
                <p className="sw-claim-error">{addAddressError}</p>
              )}
              <div className="sw-claim-actions">
                <button
                  type="button"
                  className="sw-claim-cancel"
                  onClick={closeAddAddressModal}
                >
                  {t("cancel")}
                </button>
                <button type="submit" className="sw-claim-submit">
                  {t("rewardClaimSaveAddress")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardsPage;
